// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"36c8e137","44":"10738faf","51":"41af27c3","103":"4bad5630","117":"5341e783","237":"b10c9aaf","285":"27da88eb","400":"121c7681","432":"0bd574f1","437":"5a31ca71","515":"4624bc45","521":"115295ee","525":"2e34bf65","638":"5fedcc4a","728":"5270726d","881":"ed380520"}[chunkId] + ".chunk.js";
};